import {
  FormMultiSelector,
  TooltipContent,
  TooltipTrigger,
  Typography,
  Tooltip,
  Button,
} from '@ui/components';
import {
  NotificationDtoReadStatusEnum,
  RequestFieldFilterType,
  NotificationType,
} from '@interfaces/models';
import { useTranslation } from 'react-i18next';
import { Delete } from '@ui/components/icons';
import { Control } from 'react-hook-form';
import { cn } from '@ui/utils';
import React from 'react';

interface NotificationsTableForm {
  [RequestFieldFilterType.NOTIFICATION_READ_STATUS]: string[];
  [RequestFieldFilterType.NOTIFICATION_TYPE]: string[];
}

interface NotificationsTableFiltersProps extends React.ComponentPropsWithoutRef<'div'> {
  controls: Control<NotificationsTableForm>;
  reset: () => void;
  isLoading?: boolean;
}

export function NotificationsTableFilters({
  className,
  isLoading,
  controls,
  reset,
}: NotificationsTableFiltersProps) {
  const { t } = useTranslation();

  const readStatusOptions = Object.values(NotificationDtoReadStatusEnum).map((status) => ({
    label: t(`NOTIFICATIONS.STATUS.${status}`),
    value: status,
  }));

  const severityOptions = Object.values(NotificationType).map((severity) => ({
    label: t(`NOTIFICATIONS.SEVERITY.${severity}`),
    value: severity,
  }));

  return (
    <div className={cn('flex gap-4 justify-between', className)}>
      <div className="flex gap-4 flex-wrap">
        <FormMultiSelector
          placeholder={t('NOTIFICATIONS.TABLE_HEADER_READ_STATUS')}
          name={RequestFieldFilterType.NOTIFICATION_READ_STATUS}
          className="min-w-50 w-71 flex-1"
          options={readStatusOptions}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
        <FormMultiSelector
          placeholder={t('NOTIFICATIONS.TABLE_HEADER_SEVERITY')}
          name={RequestFieldFilterType.NOTIFICATION_TYPE}
          className="min-w-50 w-71 flex-1"
          options={severityOptions}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button onClick={reset} variant="ghost" icon>
            <Delete />
          </Button>
        </TooltipTrigger>

        <TooltipContent className="w-auto">
          <Typography variant="labelXSmallBook">
            {t('NOTIFICATIONS.TABLE_HEADER_CLEAR_FILTERS')}
          </Typography>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
